import { useAppSelector } from 'src/store/hooks';

export const useSelectedAppInfo = () => {
  const selectedApp = useAppSelector(state => state.selectedPortalApp.selected_app);
  const selectedAppSection =
    selectedApp === process.env.REACT_APP_CTMS_SLUG
      ? process.env.REACT_APP_CTMS_SLUG
      : selectedApp === process.env.REACT_APP_STUDYCONDUCT_SLUG
      ? process.env.REACT_APP_STUDYCONDUCT_SLUG
      : selectedApp === process.env.REACT_APP_CLOSEOUT_SLUG
      ? process.env.REACT_APP_CLOSEOUT_SLUG
      : '';
  return {
    selectedApp,
    selectedAppSection
  };
};
